import React from 'react';
import { Circle } from 'react-native-svg';
import { createIcon } from './index';

export const IconDot = createIcon({
  viewBox: '0 0 24 24',
  title: 'A dot',
  path: [<Circle cx="12" cy="12" r="4" fill="currentColor" />],
});
